import { jsx as _jsx } from "react/jsx-runtime";
import { AwaitModules, ComponentSync, ModuleFE_AppConfig, ModuleFE_RoutingV2, TS_Loader } from '@nu-art/thunderstorm-frontend/index';
import { LoggedStatus, ModuleFE_Account } from '@nu-art/user-account-frontend';
import { Page_Login } from '../Page_Login/index.js';
import { BadImplementationException } from '@nu-art/ts-common';
export class LoginComponent extends ComponentSync {
    __onAppConfigsUpdated = (...params) => {
        this.forceUpdate();
    };
    __onLoginStatusUpdated() {
        this.forceUpdate();
    }
    __onSessionUpdated() {
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps) {
    }
    render() {
        const status = ModuleFE_Account.getLoggedStatus();
        switch (status) {
            case LoggedStatus.SESSION_TIMEOUT:
            case LoggedStatus.LOGGED_OUT:
                return _jsx(Page_Login, {});
            case LoggedStatus.VALIDATING:
                return _jsx("div", { className: 'loader-container', children: _jsx(TS_Loader, {}) });
            case LoggedStatus.LOGGED_IN: {
                return _jsx(AwaitModules, { modules: [ModuleFE_AppConfig], children: ModuleFE_RoutingV2.generateRoutes(this.props.rootRoute) });
            }
            default:
                throw new BadImplementationException(`logged status can only be one of 'LOGGED_IN', 'LOGGED_OUT' or 'VALIDATING'`);
        }
    }
}
